import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CalendarAppContextDirective } from '@modules/calendar-app/directives/app-calendar-app-context.directive';
import { CalendarEvent } from '@modules/calendar-app/types/calendar-event';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { RecurrenceTextPipe } from '@frontendlib/components/pipes/recurrence-text.pipe';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'stch-stach-event-shared',
  templateUrl: './event-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CalendarAppContextDirective,
    IconComponent,
    DateFormatPipe,
    ItemDescriptionComponent,
    RecurrenceTextPipe,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
  ],
})
export class EventSharedComponent extends SharedBaseComponent<CalendarEvent> {
  protected override readonly stitchType = StitchType.EVENT;

  protected get event(): CalendarEvent {
    return this.stitchItem?.();
  }
}
